/** Arrasto do indicador (px) a partir do qual o refresh dispara. */
export const PULL_TRIGGER_DISTANCE = 64;

/** Limite de deslocamento do indicador, mesmo com arrasto longo. */
export const PULL_MAX_DISTANCE = 96;

/**
 * Converte o arrasto do dedo no deslocamento do indicador, desacelerando
 * perto do limite para o gesto não parecer travado.
 */
export function resolvePullDistance(rawDelta: number, max = PULL_MAX_DISTANCE): number {
  if (rawDelta <= 0) return 0;
  return max * (1 - Math.exp(-rawDelta / max));
}

export function shouldTriggerRefresh(
  distance: number,
  trigger = PULL_TRIGGER_DISTANCE,
): boolean {
  return distance >= trigger;
}

/** 0 a 1, para girar o ícone conforme o usuário se aproxima do disparo. */
export function pullProgress(distance: number, trigger = PULL_TRIGGER_DISTANCE): number {
  if (distance <= 0) return 0;
  return Math.min(distance / trigger, 1);
}

interface ScrollSource {
  scrollHeight: number;
  clientHeight: number;
  scrollTop: number;
}

/**
 * O layout usa `min-h-screen`, então o conteúdo longo faz o `<main>` crescer e
 * o scroll vai para o documento. Só quando o elemento tem altura limitada é que
 * o `scrollTop` dele vale — caso contrário ficaria preso em 0 e o gesto
 * interceptaria a rolagem inteira.
 */
export function readScrollTop(element: ScrollSource, documentScrollTop: number): number {
  if (element.scrollHeight > element.clientHeight + 1) return element.scrollTop;
  return documentScrollTop;
}
